import { camelizeKeys, camelize } from 'humps';

export function replaceUtmTemplates(linkWithUtmTemplates, utmValues) {
  if (!linkWithUtmTemplates) return linkWithUtmTemplates;
  const utmParamsSource = camelizeKeys(
    utmValues || (window.beagly && window.beagly.resultParams) || {},
  );
  return linkWithUtmTemplates.replace(/{{(utm_[^}}]+)}}/g, function utmReplacer(match, paramName) {
    return utmParamsSource[camelize(paramName)] || '';
  });
}
